import { render, staticRenderFns } from "./DateDecimalForm.vue?vue&type=template&id=4f481b29&scoped=true"
import script from "./DateDecimalForm.vue?vue&type=script&lang=js"
export * from "./DateDecimalForm.vue?vue&type=script&lang=js"
import style0 from "./DateDecimalForm.vue?vue&type=style&index=0&id=4f481b29&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f481b29",
  null
  
)

export default component.exports